import { Dayjs } from 'dayjs';
import { AddComplimentaryPeriodFormValues } from 'src/components/AddComplimentaryPeriodModal/add-complimentary-period-form';
import { prepareCppData } from 'src/components/AddComplimentaryPeriodModal/util';
import { AddPreSoldMembershipFormValues } from 'src/components/AddPreSoldMembershipModal/add-pre-sold-membership-form';
import { preparePreSoldMembershipData } from 'src/components/AddPreSoldMembershipModal/util';
import { Address, Project, SubmitDay1Payload } from 'src/graphql';

export interface PrepareSubmitDay1DataParams {
  project: Project;
  address: Address;
  day1Date: Dayjs | null;
  membershipSalesNotes: string;
  sendEducationalEmails: boolean;
  cppData: AddComplimentaryPeriodFormValues;
  psmData: AddPreSoldMembershipFormValues;
  showCppForm: boolean;
  showPsmForm: boolean;
}

export function prepareSubmitDay1Data({
  project,
  address,
  day1Date,
  membershipSalesNotes,
  sendEducationalEmails,
  cppData,
  psmData,
  showCppForm,
  showPsmForm,
}: PrepareSubmitDay1DataParams): SubmitDay1Payload {
  const cppPayload = prepareCppData(cppData);
  const psmPayload = preparePreSoldMembershipData(psmData);

  return {
    projectId: project.projectId,
    addressId: address.addressId,
    partnerId: address.partnerId ?? project.partnerId,
    day1Date: day1Date?.format('YYYY-MM-DD') || '',
    membershipSalesNotes,
    sendEducationalEmails,
    cpp: showCppForm ? cppPayload : undefined,
    psm: showPsmForm ? psmPayload : undefined,
  };
}
